var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isExternal)?_c('div',{staticClass:"svg-external-icon svg-icon",style:(_vm.styleExternalIcon)}):_c('svg',{class:_vm.svgClass,attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.iconName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }